import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import "./contractDetails.css";
import bell from "../../Images/ai-bell.png";
import search from "../../Images/search-big.jpg";
import { Header } from "../../components/Header/Header";
import { useNavigate, useParams } from "react-router-dom";
import Popup from "./Popup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import Cookies from "js-cookie";
import api from "../chat/api";
import CustomDateDropdown from "./CustomDateDropdown";
import ReminderDropdown from "../Invoices/ReminderDropdown";
import PopperContainer from "./PopperContainer";
const ContractDetails = ({ isOpen, isMenuOpen }) => {
  const [contractData, setContractData] = useState(null);
  const [contractUrl, setContractUrl] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [popupState, setPopupState] = useState({});
  const [isKeyDatesOpen, setIsKeyDatesOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isMilestoneOpen, setIsMilestoneOpen] = useState(false);
  const [milestoneContent, setMilestoneContent] = useState("");
  const [editNote, setEditNode] = useState("");
  const [editingSection, setEditingSection] = useState(null);
  const [activePopup, setActivePopup] = useState(null);
  const [activeEditField, setActiveEditField] = useState(null);
  const editRef = useRef(null);
  const [contractId, setContractId] = useState(null);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
  const [reminderTimeframe, setReminderTimeframe] = useState(""); // no need to split label & days
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [edit, setEdit] = useState(false);
  const [editedData, setEditedData] = useState({});
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const [loadingAddField, setLoadingAddField] = useState(false);

  const [openSections, setOpenSections] = useState({
    termsAndConditions: false,
    financialTerms: false,
    legalClauses: false,
  });
  const [openClauses, setOpenClauses] = useState({
    termination: false,
    confidentiality: false,
    governing: false,
  });
  const location = useLocation();
  // const contractKey = location.state?.contractKey;
  const [reminder, setReminder] = useState(null);
  const daysBefore = (dateString) => {
    const reminderDate = new Date(dateString);
    const today = new Date();
    const diffInMs = reminderDate - today;
    return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  };
  const [contractName, setContractName] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [fieldPrompt, setFieldPrompt] = useState("");
  const isFilled = fieldName.trim() !== "" && fieldPrompt.trim() !== "";
  const [selectedTab, setSelectedTab] = useState("create"); // 'create' or 'manage'
  const navigate = useNavigate();
  const executionDatePickerRef = useRef(null);
  const paymentDate1PickerRef = useRef(null);
  const expirationDatePickerRef = useRef(null);
  const renewalDatePickerRef = useRef(null);
  const paymentDate2PickerRef = useRef(null);
  const [deletingField, setDeletingField] = useState(null);
  const { extractedData } = location.state || {};
  const [reminderSuccessMessage, setReminderSuccessMessage] = useState("");

  const { contractKey } = useParams();
  const handleViewMoreClick = () => {
    setIsPopupOpen(true);
  };
  const isValidDate = (date) => {
    return !isNaN(new Date(date).getTime());
  };
  const safeFormatDate = (dateString) => {
    if (!dateString || dateString === "null") return "N/A";
    const date = new Date(dateString);
    return isValid(date) ? format(date, "dd-MM-yyyy") : "N/A";
  };

  const datePickerRef = useRef(null);
  const [isMilestonePopupOpen, setIsMilestonePopupOpen] = useState(false);
  const [selectedMilestone, setSelectedMilestone] = useState({});
  const handleMilestoneViewMore = (milestone, event) => {
    event.stopPropagation();
    const buttonRect = event.target.getBoundingClientRect();
    const popupHeight = 200;
    const popupWidth = 300;

    const moveUpBy = 20;

    const top =
      buttonRect.bottom + popupHeight > window.innerHeight
        ? buttonRect.top - popupHeight - moveUpBy
        : buttonRect.bottom + moveUpBy;

    const left = Math.min(window.innerWidth - popupWidth, buttonRect.left);

    setActivePopup({
      milestone,
      position: { top: top + window.scrollY, left: left + window.scrollX },
    });
  };

  const closeMilestonePopup = () => {
    setActivePopup(null);
  };
  const [editingCustomField, setEditingCustomField] = useState(null);

  const [activeCustomerCard, setActiveCustomerCard] = useState(null); // Track active editing card
  const [activeKeyDate, setActiveKeyDate] = useState(null); // Track active editing key date
  const [activeFinancialTerm, setActiveFinancialTerm] = useState(false);
  const [activeLegalClause, setActiveLegalClause] = useState(false);
  const [activeTermsAndConditions, setActiveTermsAndConditions] =
    useState(false);
  const getDatePickerRef = (label) => {
    switch (label) {
      case "Effective Date":
        return datePickerRef;
      case "Execution Date":
        return executionDatePickerRef;
      case "Payment date 1":
        return paymentDate1PickerRef;
      case "Expiration Date":
        return expirationDatePickerRef;
      case "Renewal Date":
        return renewalDatePickerRef;
      case "Payment date 2":
        return paymentDate2PickerRef;
      default:
        return { current: null };
    }
  };

  const handleEditClick = (key) => {
    if (key === "keyDates") {
      setActiveKeyDate(activeKeyDate === "keyDates" ? null : "keyDates");
    } else if (key === "FinancialTerms") {
      setActiveFinancialTerm(!activeFinancialTerm);
    } else if (key === "LegalClauses") {
      setActiveLegalClause(!activeLegalClause);
    } else if (key === "TermsAndConditions") {
      setActiveTermsAndConditions(!activeTermsAndConditions);
    } else {
      setActiveCustomerCard(key === activeCustomerCard ? null : key);
    }
  };
  const handleAskCopilotClick = () => {
    navigate(`/Contract/contractChat?ckey=${contractKey}&cid=${contractId}`);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const toggleSection = (section) => {
    setOpenSections((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

  const toggleClause = (clause) => {
    setOpenClauses((prevClauses) => ({
      ...prevClauses,
      [clause]: !prevClauses[clause],
    }));
  };

  useEffect(() => {
    if (isModalOpen && selectedTab === "manage" && contractId) {
      fetchCustomFields();
    }
  }, [isModalOpen, selectedTab, contractId]);

  useEffect(() => {
    if (isModalOpen && contractId) {
      fetchCustomFields();
    }
  }, [isModalOpen, contractId]);

  const [reminderDate, setReminderDate] = useState(null);
  const [selectedDateType, setSelectedDateType] = useState(""); // For dropdown
  const [selectedDate, setSelectedDate] = useState("");
  const [note, setNote] = useState("");
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [isSavingReminder, setIsSavingReminder] = useState(false);
  const [isDeletingReminder, setIsDeletingReminder] = useState(false);
  const hiddenInputRef = useRef(null);
  const userEmail = localStorage.getItem("email"); // or get from props/api

  const formatReminderDate = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) return "N/A";
    return format(new Date(dateString), "dd-MM-yyyy");
  };

  const [reminders, setReminders] = useState([]); // instead of `reminder`

  const fetchReminder = async () => {
    try {
      const response = await api.get(
        `/api/v1/contract/get-contract-reminder/${contractKey}/`
      );
      if (response.status === 200) {
        setReminders(response.data.reminders || []);
      }
    } catch (error) {
      console.error("Reminder fetch error", error);
    }
  };

  const handleSaveReminder = async () => {
    if (!selectedDateType || !reminderTimeframe) return;

    setIsSavingReminder(true);
    try {
      await api.post(`/api/v1/contract/create-contract-reminder/`, {
        contract_key: contractKey,
        date_type: selectedDateType,
        reminder_timeframe: reminderTimeframe
          .replace(/\s+/g, "_")
          .toLowerCase(),
        note,
      });
      setIsReminderModalOpen(false);
      fetchReminder();
      fetchContractDetails(); // refresh data

      setReminderSuccessMessage("Reminder saved successfully!");
      setTimeout(() => setReminderSuccessMessage(""), 3000);
    } catch (err) {
      // ✅ Extract error message
      const errorText =
        err?.response?.data?.error ||
        err?.response?.data?.msg ||
        "Failed to save/update reminder";

      setErrorMessage(errorText);
      setShowErrorPopup(true);
      setIsReminderModalOpen(false); // ✅ Close modal on failure too
    } finally {
      setIsSavingReminder(false);
    }
  };

  const handleUpdateReminder = async () => {
    setIsSavingReminder(true);
    try {
      await api.patch(`/api/v1/contract/update-contract-reminder/`, {
        contract_key: contractKey,
        date_type: selectedDateType,
        reminder_timeframe: reminderTimeframe
          .replace(/\s+/g, "_")
          .toLowerCase(),

        note,
      });
      setIsReminderModalOpen(false);
      fetchContractDetails();
      setReminderSuccessMessage("Reminder updated successfully!");
      setTimeout(() => setReminderSuccessMessage(""), 3000);
    } catch (err) {
      const errorText =
        err?.response?.data?.error ||
        err?.response?.data?.msg ||
        "Failed to save/update reminder";

      setErrorMessage(errorText);
      setShowErrorPopup(true);
      setIsReminderModalOpen(false); // ✅ Close modal on failure too
    } finally {
      setIsSavingReminder(false);
    }
  };

  const handleDeleteReminder = async (dateType) => {
    setIsDeletingReminder(true);
    try {
      await api.delete(`/api/v1/contract/delete-contract-reminder/`, {
        data: {
          contract_key: contractKey,
          date_type: dateType,
        },
      });
      setIsReminderModalOpen(false);
      fetchContractDetails();
    } catch (err) {
      const errorText =
        err?.response?.data?.error ||
        err?.response?.data?.msg ||
        "Failed to save/update reminder";

      setErrorMessage(errorText);
      setShowErrorPopup(true);
      setIsReminderModalOpen(false); // ✅ Close modal on failure too
    } finally {
      setIsDeletingReminder(false);
    }
  };

  const fetchCustomFields = async () => {
    setCustomFieldsLoading(true);
    try {
      const response = await api.get(
        `api/v1/contract/list-field/${contractId}/`
      );
      if (response.status === 200) {
        setCustomFields(response.data.custom_fields || []);
      }
    } catch (error) {
      console.error("Error fetching custom fields:", error);
    } finally {
      setCustomFieldsLoading(false);
    }
  };

  const handleSaveCustomField = async (fieldKey) => {
    const updatedValue = editedData[fieldKey];
    try {
      const response = await api.post(
        `api/v1/contract/edit-contract-details/${contractKey}/`,
        {
          edited_data: { [fieldKey]: updatedValue },
        }
      );
      if (response.status === 200) {
        setContractData((prevData) => ({
          ...prevData,
          _custom_fields: {
            ...prevData._custom_fields,
            [fieldKey]: updatedValue,
          },
        }));
        setEditingCustomField(null);
      }
    } catch (error) {
      setEditingCustomField(null);
    }
  };

  const fetchContractDetails = async () => {
    try {
      const response = await api.post(
        `api/v1/contract/extract-contract-info/`,
        {
          contract_key: contractKey,
        }
      );

      if (response.status === 200) {
        setContractData(response.data.contract_data);
        setEditedData(response.data.contract_data);
        setUserNote(response.data.contract_data?.note || "");
        setContractId(response.data.contract_id);
        setReminders(response.data.reminders || []);
      }
    } catch (error) {
   
      alert(
        error.response?.data.msg ||
          "An error occurred while fetching contract details."
      );
    }
  };

  useEffect(() => {
    if (contractKey) fetchContractDetails();
  }, [contractKey, edit]);

  const handleDeleteField = async (fieldName) => {
    if (!contractId) return;

    try {
      const response = await api.delete(
        `api/v1/contract/delete-field/${contractId}/`,
        {
          data: { field: fieldName },
        }
      );

      if (response.status === 200) {
        // Refresh list
        fetchCustomFields();
      }
    } catch (error) {
      console.error("Delete failed:", error.response?.data || error.message);
      alert("Failed to delete field.");
    } finally {
      setDeletingField(null); // ✅ reset the button
    }
  };

  const handleAddField = async () => {
    if (!isFilled || !contractId) return;
    setLoadingAddField(true);

    try {
      const response = await api.post(
        `api/v1/contract/create-field/${contractId}/`,
        {
          field: fieldName,
          description: fieldPrompt,
        }
      );

      if (response.status === 201) {
        setFieldName("");
        setFieldPrompt("");
        await fetchCustomFields(); // Refresh the list

        // ✅ Re-fetch the full contract details with extracted values
        const extractRes = await api.post(
          `api/v1/contract/extract-contract-info/`,
          {
            contract_key: contractKey,
          }
        );

        if (extractRes.status === 200) {
          setContractData(extractRes.data.contract_data);
          setEditedData(extractRes.data.contract_data);
          setUserNote(extractRes.data.contract_data?.note || "");
          setContractId(extractRes.data.contract_id);
        }

        setIsModalOpen(false); // Close modal after success
      }
    } catch (error) {
      alert(
        "Error creating field: " + (error.response?.data?.msg || error.message)
      );
    } finally {
      setLoadingAddField(false);
    }
  };

  const viewContract = async () => {
    try {
      const response = await api.get(
        `api/v1/contract/view-contract/${contractKey}/`
      );

      if (response.status === 200 && response.data.contract_url) {
        setContractUrl(response.data.contract_url);
        setIsPopupOpen(true);
      } else {
        alert(response.data.msg || "Failed to retrieve contract.");
      }
    } catch (error) {
      alert(
        error.response?.data.msg ||
          "An unexpected error occurred while retrieving the contract."
      );
    }
  };

  const saveNote = async (note) => {
    if (!note.trim()) return; // Avoid saving empty notes
    const token = localStorage.getItem("token");


    setIsSaving(true);
    try {
      const response = await api.post(
        `api/v1/contract/edit-contract-details/${contractKey}/`,
        {
          edited_data: { dummyField: "keep this non-empty" }, // Ensure it’s not empty
          note: note.trim(),
        }
      );


      if (response.status === 200) {
      }
    } catch (error) {
      console.error(
        "Error saving note:",
        error.response?.data || error.message
      );
      alert("An error occurred while saving the note.");
    } finally {
      setIsSaving(false);
    }
  };

  const notesRef = useRef(null);
  const [userNote, setUserNote] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isEditingNote, setIsEditingNote] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notesRef.current && !notesRef.current.contains(event.target)) {
        if (isEditingNote) {
          saveNote(userNote); // Call API only if the user was editing
          setIsEditingNote(false); // Reset the flag
        }
      }

      if (editRef.current && !editRef.current.contains(event.target)) {
        setActiveCustomerCard(null);
        setActiveKeyDate(null);
        setActiveLegalClause(false); // Reset editing mode
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeEditField, editedData, userNote, isEditingNote, activeLegalClause]);

  const handleInputChange = (field, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleDateChange = (field, date) => {
    if (date) {
      // Adjust date to remove timezone offset
      const localDate = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
      );
      const formattedDate = format(localDate, "yyyy-MM-dd"); // Ensure it's formatted as 'yyyy-MM-dd'
      handleInputChange(field, formattedDate);
    } else {
      handleInputChange(field, null); // Handle invalid or cleared date
    }
  };

  const handleEditContract = async () => {
    try {
      const response = await api.post(
        `api/v1/contract/edit-contract-details/${contractKey}/`,
        {
          edited_data: {
            ...editedData,
          },
          note: userNote,
        }
      );

      if (response.status === 200) {
        setIsEditModalOpen(false);
        setContractData(response.data.data);
        setUserNote(response.data.data?.note || "");
      }
    } catch (error) {}
  };

  const handleEdit = () => {
    if (edit === true) {
      handleEditContract();
      setEdit(false);
    } else {
      setEdit(true);
      setIsMilestoneOpen(true);
    }
  };

  const handleSaveOnBlur = (field) => {
    api
      .post(`api/v1/contract/edit-contract-details/${contractKey}/`, {
        edited_data: { [field]: editedData[field] },
      })
      .then((response) => {
        if (response.status === 200) {
          setContractData((prevData) => ({
            ...prevData,
            [field]: editedData[field],
          }));
          setActiveEditField(null);
          setEdit(false);
        }
      })
      .catch((error) => {
        console.error(
          `Error saving field "${field}":`,
          error.response?.data?.msg || error.message
        );
      });
  };
  const isMaxFieldsReached = customFields.length >= 3;

  const cardRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        if (edit) {
          handleSaveOnBlur("Client name");
          handleSaveOnBlur("Client Contact Person name");
          handleSaveOnBlur("Client address");
          handleSaveOnBlur("Client Contact Person telephone");
          handleSaveOnBlur("Client Contact Person email");
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [edit, handleSaveOnBlur]);

  return (
    <div
      className="full_Container"
      style={{
        backgroundColor: "var(--Background-main, #FEF9F7)",
        minHeight: "100vh",
      }}
    >
      {/* 
        Added Tailwind classes:
        - sticky: Makes the element sticky
        - top-0: Sticks it to the very top of the screen
        - z-50: Ensures it stays above the scrolling content
        - Added background color so scrolling text doesn't show through 
      */}
      <div 
        className="header-container sticky top-0 z-50 pb-2" 
        style={{ backgroundColor: "var(--Background-main, #FEF9F7)" }}
      >
        <Header
          icon="/arrow-back.svg"
          name="Go to Contracts"
          // askCoPiolt={true}
          contractKey={contractKey}
          contractId={contractId}
        />
      </div>
      
      <div className="w-full mt-4 flex-grow px-2">
        {contractData ? (
          <>
            <header className="header">
              <div
                className="header-content-invoices"
                style={{
                  width: "100%",
                }}
              >
                <div className="contract-info">
                  {/* <img
                      src="/hicon.svg"
                      alt="icon"
                      className="contract-icon"
                    /> */}
                  <div>
                    <h1 className="contract-title pl-6 pt-3 flex">
                      <img
                        src="/due-red-dots.svg"
                        alt="Due Icon"
                        style={{
                          width: "24px",

                          height: "24px",
                          marginRight: "6px",

                          verticalAlign: "middle",
                        }}
                      />
                      {contractData["Contract Title"] || "N/A"}
                    </h1>
                    <p className="contract-type pl-[3.3rem] pt-1">
                      Contract type:{" "}
                      <span>{contractData["Contract Type"] || "N/A"}</span>
                    </p>

                    <button
                      onClick={viewContract}
                      className="flex items-center justify-center gap-[6px] px-3 py-2 rounded border border-[rgba(0,0,0,0.10)] bg-[#FEF9F7] ml-[3.3rem] mt-2 cursor-pointer"
                    >
                      <span className="text-[15px] font-medium text-gray-700">
                        View Contract
                      </span>
                      <span className="pt-1">
                        <img src="/eye-invoice.svg" alt="View" />
                      </span>
                    </button>
                  </div>
                </div>
                <div className="invoice-buttons-wrapper">
                  <div className="invoice-buttons-group">
                    <button
                      className="view-contract-button-invoice"
                      onClick={handleAskCopilotClick}
                    >
                      <img
                        src="/ai-icon.svg"
                        alt="AI Icon"
                        className="h-4 w-4"
                      />
                      <span>Ask Copilot</span>
                    </button>
                  </div>
                </div>
              </div>
            </header>

            {contractUrl && isPopupOpen && (
              <div className="contract-modal-overlay" onClick={closePopup}>
                <div
                  className="contract-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    // className="contract-close-button"
                    onClick={closePopup}
                  >
                    {/* &times; */}
                  </button>
                  <iframe
                    src={contractUrl}
                    title="Contract Document"
                    className="contract-iframe"
                  ></iframe>
                </div>
              </div>
            )}

            <h4 className="customer-header mt-2">
              <span role="img" aria-label="icon">
                <img src="/custDetails.svg" alt="" />
              </span>{" "}
              Customer Details
            </h4>
            <section
              className="customer-details-invoices"
              style={{
                width: "100%",
              }}
            >
              <div className="customer-cards">
                <div className="customer-card-invoice">
                  <div className="flex items-center relative w-full gap-2">
                    <span className="party-label">Customer Party A:</span>
                    <div
                      style={{
                        flexGrow: 1,
                        maxWidth: "calc(100% - 40px)",
                        wordWrap: "break-word",
                      }}
                    >
                      {activeCustomerCard === "customerA" ? (
                        <input
                          className="w-[267px] h-[27px] pl-1 rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[5px] font-outfit ml-3"
                          type="text"
                          value={
                            editedData["Client name"] !== undefined
                              ? editedData["Client name"]
                              : contractData["Client name"] || ""
                          }
                          onChange={(e) =>
                            handleInputChange("Client name", e.target.value)
                          }
                          onBlur={() => {
                            handleSaveOnBlur("Client name");
                            setActiveCustomerCard(null);
                          }}
                          // onFocus={() => handleEditClick("Client name")}
                        />
                      ) : (
                        <strong
                          className="cust-details-customer-a"
                          style={{
                            display: "block",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {contractData["Client name"] || "N/A"}
                        </strong>
                      )}
                    </div>

                    {!activeCustomerCard && (
                      <img
                        src="/edit-icon.svg"
                        alt="Edit"
                        className="edit-icon cursor-pointer w-[20px] h-[20px] absolute right-[10px]  transform -translate-y-1/2"
                        onClick={() => handleEditClick("customerA")}
                      />
                    )}
                  </div>
                  <div className="signatory-invoice">
                    <strong>Customer Signatory:</strong>{" "}
                    {activeCustomerCard === "customerA" ? (
                      <input
                        className="pl-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[4px] font-outfit ml-1"
                        type="text"
                        value={
                          editedData["Client Contact Person name"] !== undefined
                            ? editedData["Client Contact Person name"]
                            : contractData["Client Contact Person name"] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "Client Contact Person name",
                            e.target.value
                          )
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Client Contact Person name");
                          setActiveCustomerCard(null); // Close edit mode on blur
                        }}
                      />
                    ) : (
                      <span className="cust-details-signatory">
                        {contractData["Client Contact Person name"] || "N/A"}
                      </span>
                    )}
                  </div>
                  <p className="signatory-invoice">
                    <strong>Address:</strong>{" "}
                    {activeCustomerCard === "customerA" ? (
                      <input
                        className="pl-1 w-[312px] h-[65px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[42px] font-outfit ml-20"
                        type="text"
                        value={
                          editedData["Client address"] !== undefined
                            ? editedData["Client address"]
                            : contractData["Client address"] || ""
                        }
                        onChange={(e) =>
                          handleInputChange("Client address", e.target.value)
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Client address");
                          setActiveCustomerCard(null);
                        }}
                      />
                    ) : (
                      <span className="cust-details-invoice-try">
                        {contractData["Client address"] || "N/A"}
                      </span>
                    )}
                  </p>
                  <div className="signatory-invoice">
                    <strong>Phone Number:</strong>{" "}
                    {activeCustomerCard === "customerA" ? (
                      <input
                        className="pl-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[2px] font-outfit ml-8"
                        type="text"
                        value={
                          editedData["Client Contact Person telephone"] !==
                          undefined
                            ? editedData["Client Contact Person telephone"]
                            : contractData["Client Contact Person telephone"] ||
                              ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "Client Contact Person telephone",
                            e.target.value
                          )
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Client Contact Person telephone");
                          setActiveCustomerCard(null);
                        }}
                      />
                    ) : (
                      <span className="phone-datas">
                        {contractData["Client Contact Person telephone"] ||
                          "N/A"}
                      </span>
                    )}
                  </div>
                  <div className="signatory-invoice">
                    <strong>Email Address:</strong>{" "}
                    {activeCustomerCard === "customerA" ? (
                      <input
                        className="pl-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[2px] font-outfit ml-10"
                        type="text"
                        value={
                          editedData["Client Contact Person email"] !==
                          undefined
                            ? editedData["Client Contact Person email"]
                            : contractData["Client Contact Person email"] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "Client Contact Person email",
                            e.target.value
                          )
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Client Contact Person email");
                          setActiveCustomerCard(null);
                        }}
                      />
                    ) : (
                      <span className="email-datas">
                        {contractData["Client Contact Person email"] || "N/A"}
                      </span>
                    )}
                  </div>
                </div>
                <div className="w-[2px] h-[178px] bg-[rgba(0,0,0,0.10)] mt-4"></div>

                <div className="customer-card-invoice">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      position: "relative",
                      width: "100%",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span
                      className="party-label"
                      style={{
                        fontWeight: "bold",
                        flexShrink: 0,
                      }}
                    >
                      Customer Party B:
                    </span>
                    <div
                      style={{
                        flexGrow: 1,
                        maxWidth: "calc(100% - 200px)",
                        wordWrap: "break-word",
                      }}
                    >
                      {activeCustomerCard === "customerB" ? (
                        <input
                          className="w-[267px] h-[27px] pl-1 rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[1px] font-outfit ml-1"
                          type="text"
                          value={
                            editedData["Company Name"] !== undefined
                              ? editedData["Company Name"]
                              : contractData["Company Name"] || ""
                          }
                          onChange={(e) =>
                            handleInputChange("Company Name", e.target.value)
                          }
                          onBlur={() => {
                            handleSaveOnBlur("Company Name");
                            setActiveCustomerCard(null);
                          }}
                        />
                      ) : (
                        <strong
                          className="cust-details-customer-a"
                          style={{
                            display: "block",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {contractData["Company Name"] || "N/A"}{" "}
                        </strong>
                      )}
                    </div>

                    {!activeCustomerCard && (
                      <img
                        src="/edit-icon.svg"
                        alt="Edit"
                        className="edit-icon cursor-pointer w-[20px] h-[20px] absolute right-[10px]  transform -translate-y-1/2"
                        onClick={() => handleEditClick("customerB")}
                      />
                    )}
                  </div>

                  <p className="contact-info-invoice">
                    <strong>Customer Signatory:</strong>{" "}
                    {activeCustomerCard === "customerB" ? (
                      <input
                        className="pl-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[4px] font-outfit ml-1"
                        type="text"
                        value={
                          editedData["Company Contact Person Name"] !==
                          undefined
                            ? editedData["Company Contact Person Name"]
                            : contractData["Company Contact Person Name"] || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "Company Contact Person Name",
                            e.target.value
                          )
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Company Contact Person Name");
                          setActiveCustomerCard(null);
                        }}
                      />
                    ) : (
                      <span className="cust-details-signatory">
                        {contractData["Company Contact Person Name"] || "N/A"}
                      </span>
                    )}
                  </p>

                  <p className="contact-info-invoice">
                    <strong>Address:</strong>{" "}
                    {activeCustomerCard === "customerB" ? (
                      <input
                        className="pl-1 w-[312px] h-[65px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[42px] font-outfit ml-20"
                        type="text"
                        value={
                          editedData["Company Address"] !== undefined
                            ? editedData["Company Address"]
                            : contractData["Company Address"] || ""
                        }
                        onChange={(e) =>
                          handleInputChange("Company Address", e.target.value)
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Company Address");
                          setActiveCustomerCard(null);
                        }}
                      />
                    ) : (
                      <span className="cust-details-invoice-try">
                        {contractData["Company Address"] || "N/A"}
                      </span>
                    )}
                  </p>

                  <div className="contact-info-invoice">
                    <strong className="phone-number-styling">
                      Phone Number:
                    </strong>{" "}
                    {activeCustomerCard === "customerB" ? (
                      <input
                        className="pl-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[2px] font-outfit ml-6"
                        type="text"
                        value={
                          editedData["Company telephone"] !== undefined
                            ? editedData["Company telephone"]
                            : contractData["Company telephone"] || ""
                        }
                        onChange={(e) =>
                          handleInputChange("Company telephone", e.target.value)
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Company telephone");
                          setActiveCustomerCard(null);
                        }}
                      />
                    ) : (
                      <span className="phone-data-lefts">
                        {contractData["Company telephone"] || "N/A"}
                      </span>
                    )}
                  </div>

                  <div className="contact-info-invoice">
                    <strong className="phone-number-styling">
                      Email Address:
                    </strong>{" "}
                    {activeCustomerCard === "customerB" ? (
                      <input
                        className="pl-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[2px] font-outfit ml-8 mt-1"
                        type="text"
                        value={
                          editedData["Company email"] !== undefined
                            ? editedData["Company email"]
                            : contractData["Company email"] || ""
                        }
                        onChange={(e) =>
                          handleInputChange("Company email", e.target.value)
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Company email");
                          setActiveCustomerCard(null);
                        }}
                      />
                    ) : (
                      <span className="email-datas-lefts">
                        {contractData["Company email"] || "N/A"}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </section>

            {contractData?._custom_fields &&
              Object.keys(contractData._custom_fields).length > 0 && (
                <>
                  <div className="flex flex-col space-y-4 mt-2">
                    {Object.entries(contractData._custom_fields).map(
                      ([key, value]) =>
                        value || value !== "null" ? (
                          <div
                            className="accordion-item-invoicees  mt-4"
                            key={key}
                            style={{
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "30px",
                                  marginTop: "10px",
                                }}
                              >
                                <h3 className="payment-info-title-invoice">
                                  {key}
                                </h3>
                                <img
                                  src="/invoice-bulblogo-invoicee.svg"
                                  alt="Bullet Icon"
                                  className=" ml-2"
                                />
                              </div>
                              <img
                                src="/edit-icon.svg"
                                alt="Edit"
                                style={{
                                  cursor: "pointer",
                                  width: "26px",
                                  height: "26px",
                                  marginRight: "10px",
                                  marginTop: "10px",
                                }}
                                onClick={() => setEditingCustomField(key)}
                              />
                            </div>

                            <div
                              className="ml-8 mb-3"
                              style={{ borderBottom: "10x" }}
                            >
                              {editingCustomField === key ? (
                                <textarea
                                  className="w-[95%] h-[100px] rounded-lg border border-gray-300 bg-[#FEF9F7] p-2 outline-none text-sm text-gray-800"
                                  value={
                                    editedData[key] !== undefined
                                      ? editedData[key]
                                      : value
                                  }
                                  onChange={(e) =>
                                    handleInputChange(key, e.target.value)
                                  }
                                  onBlur={() => handleSaveCustomField(key)}
                                  autoFocus
                                />
                              ) : (
                                <div className="max-h-[300px] overflow-y-auto">
                                 {(() => {
  let parsedValue = null;
  try {
    parsedValue = typeof value === "string" ? JSON.parse(value) : value;
  } catch {
    parsedValue = null;
  }

  // ✅ Case 0: Array of objects (like line items)
if (
  Array.isArray(parsedValue) &&
  parsedValue.length > 0 &&
  typeof parsedValue[0] === "object" &&
  !Array.isArray(parsedValue[0])
) {
  const headers = Array.from(
    new Set(parsedValue.flatMap((obj) => Object.keys(obj)))
  );

  return (
    <table className="w-[95%] mt-2 border border-gray-200 text-sm mb-2">
      <thead>
        <tr>
          {headers.map((h, i) => (
            <th
              key={i}
              className="border border-gray-300 px-3 py-2 bg-gray-100 text-left whitespace-pre-wrap"
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {parsedValue.map((rowObj, rowIndex) => (
          <tr key={rowIndex}>
            {headers.map((h, j) => (
              <td
                key={j}
                className="border border-gray-300 px-3 py-2 whitespace-pre-wrap"
              >
                {rowObj[h] ?? "—"}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}


  // ✅ Case 2: Markdown table
  if (
    typeof value === "string" &&
    value.includes("|") &&
    value.split("\n").length > 2
  ) {
    const lines = value.trim().split("\n").filter(Boolean);
    const headers = lines[0]
      .split("|")
      .map((h) => h.trim())
      .filter(Boolean);
    const rows = lines.slice(2).map((line) =>
      line
        .split("|")
        .map((cell) => cell.trim())
        .filter(Boolean)
    );

    return (
      <table className="w-[95%] mt-2 border border-gray-200 text-sm mb-2">
        <thead>
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                className="border border-gray-300 px-3 py-2 bg-gray-100 text-left whitespace-pre-wrap"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td
                  key={j}
                  className="border border-gray-300 px-3 py-2 whitespace-pre-wrap"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  // ✅ Case 3: Mixed paragraph + key: value block
  if (typeof value === "string") {
    const lines = value.split("\n");
    const groups = [];
    let currentParagraph = [];
    let currentTable = [];

    const flushGroup = () => {
      if (currentParagraph.length || currentTable.length) {
        groups.push({
          paragraph: currentParagraph,
          table: currentTable,
        });
        currentParagraph = [];
        currentTable = [];
      }
    };

    lines.forEach((line) => {
      if (!line.trim()) return;
      const colonIndex = line.indexOf(":");
      const key = line.slice(0, colonIndex).trim();
      const val = line.slice(colonIndex + 1).trim();

      if (
        colonIndex > 0 &&
        key.length < 50 &&
        line.length < 150 &&
        val
      ) {
        currentTable.push([key, val]);
      } else {
        flushGroup();
        currentParagraph.push(line);
      }
    });

    flushGroup();

    return (
      <div className="w-[96%] whitespace-pre-wrap break-words text-[#18101C] font-[Outfit] text-[16px] font-medium leading-[23px] tracking-[0.16px] mt-1">
        {groups.map((group, index) => (
          <div key={index} className="mb-3">
            {group.paragraph.map((line, i) => (
              <p key={i} className="mb-1">
                {line}
              </p>
            ))}

            {group.table.length > 0 && (
              <table className="w-[95%] mt-2 border border-gray-200 text-sm">
                <thead>
                  <tr>
                    <th className="border border-gray-300 px-3 py-2 bg-gray-100 text-left">
                      Field
                    </th>
                    <th className="border border-gray-300 px-3 py-2 bg-gray-100 text-left">
                      Value
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {group.table.map(([k, v], i) => (
                    <tr key={i}>
                      <td className="border border-gray-300 px-3 py-2 font-semibold w-1/3">
                        {k}
                      </td>
                      <td className="border border-gray-300 px-3 py-2">
                        {v}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ))}
      </div>
    );
  }

  // ✅ Fallback
  return (
    <p className="w-[96%] whitespace-pre-wrap break-words text-[#18101C] font-[Outfit] text-[16px] font-medium leading-[23px] tracking-[0.16px] mt-1">
      {(value || "").trim()}
    </p>
  );
})()}

                                </div>
                              )}
                            </div>
                          </div>
                        ) : null
                    )}
                  </div>
                </>
              )}

            <section className="key-dates-wrapper mt-3">
              <div
                className="key-datessss"
                style={{
                  width: "100%",
                }}
              >
                <div
                  className="date-details"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "32px",
                    marginTop: "20px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Left Column: Key Dates */}
                  <div
                    style={{ flex: 1, minWidth: "360px" }}
                    className="left-side-box-key-dates relative"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      className="mt-1"
                    >
                      <h3 className="key-dates-heading-design">Key Dates</h3>
                      <img src="/key-datesf.svg" alt="Key Dates Icon" />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                        className="absolute right-2"
                      >
                        <img
                          src="/edit-icon.svg"
                          alt="Edit"
                          style={{
                            cursor: "pointer",
                            width: "22px",
                            height: "22px",
                          }}
                          onClick={() => handleEditClick("keyDates")}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-y-6 gap-x-4 mt-6 ml-2">
                      {[
                        {
                          label: "Effective Date",
                          icon: "/yellowCal.svg",
                        },
                        {
                          label: "Execution Date",
                          icon: "/yellowCal.svg",
                        },
                        {
                          label: "Payment date 1",
                          icon: "/yellowCal.svg",
                        },
                        {
                          label: "Expiration Date",
                          icon: "/yellowCal.svg",
                        },
                        {
                          label: "Renewal Date",
                          icon: "/yellowCal.svg",
                        },
                        {
                          label: "Payment date 2",
                          icon: "/yellowCal.svg",
                        },
                      ].map(({ label, icon }) => (
                        <div key={label}>
                          <p className="text-[#73607B] text-sm font-medium mb-1">
                            {label}
                          </p>
                          <div className="flex items-center gap-2">
                            {activeKeyDate === "keyDates" ? (
                              <div
                                className="unique"
                                style={{
                                  position: "relative",
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                              >
                                <DatePicker
                                  ref={getDatePickerRef(label)}
                                  selected={
                                    editedData[label] &&
                                    !isNaN(new Date(editedData[label]))
                                      ? new Date(editedData[label])
                                      : contractData[label] &&
                                        !isNaN(new Date(contractData[label]))
                                      ? new Date(contractData[label])
                                      : null
                                  }
                                  onChange={(date) =>
                                    handleDateChange(label, date)
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  className="unique-input"
                                  placeholderText="dd-MM-yyyy"
                                  onBlur={() => {
                                    handleSaveOnBlur(label);
                                    setActiveKeyDate(null);
                                  }}
                                  popperPlacement="bottom-start"
                                  popperContainer={PopperContainer}
                                />
                                <img
                                  className="unique-calendar-icon"
                                  src="/calendar.svg"
                                  alt="Calendar"
                                  onClick={() =>
                                    getDatePickerRef(label).current.setOpen(
                                      true
                                    )
                                  }
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "5px",
                                  }}
                                />
                              </div>
                            ) : (
                              <>
                                <span className="font-semibold-deisgn-cutom">
                                  {safeFormatDate(contractData[label])}
                                </span>
                                <img
                                  src={
                                    reminders.some(
                                      (r) =>
                                        r.date_type.toLowerCase().trim() ===
                                        label.toLowerCase().trim()
                                    )
                                      ? "/yellowRemCal.svg" // if reminder exists
                                      : icon // default icon
                                  }
                                  onClick={() => {
                                    const existingReminder = reminders.find(
                                      (r) =>
                                        r.date_type.toLowerCase().trim() ===
                                        label.toLowerCase().trim()
                                    );

                                    setSelectedDateType(label);
                                    setReminderTimeframe(
                                      existingReminder?.timeframe?.replace(
                                        /_/g,
                                        " "
                                      ) || ""
                                    );
                                    setNote(existingReminder?.note || "");
                                    setReminderDate(
                                      existingReminder?.reminder_date || null
                                    );
                                    setIsReminderModalOpen(true);
                                    fetchReminder();
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Right Column: Milestones */}
                  <div
                    style={{
                      flex: 1,
                      minWidth: "360px",
                      maxWidth: "533px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "12px",
                        border: "1px solid rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#FFF",
                        paddingTop: "7px",
                        paddingLeft: "19px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "0px",
                        }}
                      >
                        <h4 className="key-dates-heading-design mt-1">
                          Milestone dates
                        </h4>
                        <img src="/key-datesf.svg" alt="Key Dates Icon" />
                      </div>
                      {[1, 2, 3, 4, 5].filter((num) => {
                        const date = contractData[`Milestone Date ${num}`];
                        const desc =
                          contractData[`Milestone Date ${num} Description`];
                        return (
                          (date && date !== "null") || (desc && desc !== "null")
                        );
                      }).length === 0 ? (
                        <div
                          style={{
                            height: "151px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src="/not-available-icon.svg"
                            alt="Not Available"
                            style={{ width: "60px", marginBottom: "10px" }}
                          />
                          <p className="text-[#4B465C] font-medium text-sm">
                            Not Available
                          </p>
                        </div>
                      ) : (
                        <div
                          className="milestone-scroll-list mt-4"
                          style={{
                            maxHeight: "135px", // Actual scrollable area below the title
                            overflowY: "auto",
                            paddingRight: "8px",
                          }}
                        >
                          {[1, 2, 3, 4, 5].map((num, idx, arr) => {
                            const dateKey = `Milestone Date ${num}`;
                            const descKey = `Milestone Date ${num} Description`;
                            const date = contractData[dateKey];
                            const desc = contractData[descKey];

                            if (!date && !desc) return null;

                            const reminderExists = reminders.some(
                              (r) =>
                                r.date_type.toLowerCase().trim() ===
                                dateKey.toLowerCase().trim()
                            );
                            const matchedReminder = reminders.find(
                              (r) =>
                                r.date_type.toLowerCase().trim() ===
                                dateKey.toLowerCase().trim()
                            );

                            return (
                              <div
                                key={num}
                                className="flex gap-4 relative mb-6"
                              >
                                <div className="flex flex-col items-center">
                                  <div className="mt-0.5">
                                    {/* Dot Timeline */}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="none"
                                    >
                                      <circle
                                        cx="10"
                                        cy="10"
                                        r="10"
                                        fill="#8B55DD"
                                        fillOpacity="0.16"
                                      />
                                      <circle
                                        cx="10"
                                        cy="10"
                                        r="8"
                                        fill="#8B55DD"
                                        fillOpacity="0.28"
                                      />
                                      <circle
                                        cx="10"
                                        cy="10"
                                        r="6"
                                        fill="#8B55DD"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                <div style={{ marginTop: "-1px" }}>
                                  <div className="flex items-center gap-2">
                                    <p className="font-semibold-deisgn-cutom">
                                      {date || "—"}
                                    </p>
                                    <img
                                      src={
                                        reminderExists
                                          ? "/yellowRemCal.svg"
                                          : "/yellowCal.svg"
                                      }
                                      alt="Reminder"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setSelectedDateType(dateKey); // e.g., "Milestone Date 1"
                                        setReminderTimeframe(
                                          matchedReminder?.timeframe?.replace(
                                            /_/g,
                                            " "
                                          ) || ""
                                        );
                                        setNote(matchedReminder?.note || "");
                                        setReminderDate(
                                          matchedReminder?.reminder_date || null
                                        );
                                        setIsReminderModalOpen(true);
                                        fetchReminder(); // refresh reminder list
                                      }}
                                    />
                                  </div>
                                  <p className="text-[#73607B] text-sm mt-1 leading-snug">
                                    {desc || "—"}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Milestone Popup */}
                {activePopup && (
                  <div
                    className="popup-attached"
                    style={{
                      position: "fixed",
                      top: "40%",
                      left: "58%",
                      zIndex: 1000,
                      backgroundColor: "white",
                      padding: "17px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="popup-header">
                      <button className="milestone-button">
                        Milestone Date
                      </button>
                      <img
                        src="/mileStone-icon.svg"
                        alt=""
                        className="mileStone-icon"
                      />
                      <h3 className="popup-date">
                        {activePopup.milestone.date &&
                        activePopup.milestone.date !== "null"
                          ? activePopup.milestone.date
                          : "Date unavailable"}
                      </h3>
                      <button
                        className="popup-close-contract"
                        onClick={closeMilestonePopup}
                      >
                        <img src="/cross-button.svg" alt="cross" />
                      </button>
                    </div>
                    <div className="popup-body">
                      <p className="popup-description">
                        {activePopup.milestone.description &&
                        activePopup.milestone.description !== "null"
                          ? activePopup.milestone.description
                          : "Milestone details are not available."}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </section>

            <section
              className="mt-3"
              style={{
                width: "100%",
              }}
            >
              <div className="accordion-item-invoice">
                <div
                  className="accordion-header"
                  onClick={(e) => {
                    if (!activeTermsAndConditions) {
                      toggleSection("termsAndConditions");
                    }
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <img src="/term.svg" alt="" className="icon" />
                    <p className="Terms-condition-title">
                      Terms and Conditions
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    {openSections.termsAndConditions &&
                      !activeTermsAndConditions && (
                        <img
                          src="/edit-icon.svg"
                          alt="Edit"
                          style={{
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                            marginRight: "2px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick("TermsAndConditions");
                          }}
                        />
                      )}
                    <img
                      src={
                        openSections.termsAndConditions
                          ? "/up-arrow.svg"
                          : "/down-arrow.svg"
                      }
                      alt={
                        openSections.termsAndConditions ? "Collapse" : "Expand"
                      }
                      style={{
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </div>
                </div>

                {openSections.termsAndConditions && (
                  <div className="accordion-content">
                    <div className="terms-and-conditions-content">
                      {/* Contract Duration */}
                      <div className="contract-duration">
                        <p className="label-terms">Contract Duration</p>
                        <div className="contract-duration-container">
                          {/* Contract From Date */}
                          <div className="contract-date">
                            <span className="date-label">From</span>
                            {activeTermsAndConditions ? (
                              <div className="datepicker-wrapper">
                                <DatePicker
                                  ref={fromDateRef}
                                  selected={
                                    editedData["Contract effective date"]
                                      ? new Date(
                                          editedData["Contract effective date"]
                                        )
                                      : contractData["Contract effective date"]
                                      ? new Date(
                                          contractData[
                                            "Contract effective date"
                                          ]
                                        )
                                      : null
                                  }
                                  onChange={(date) =>
                                    handleDateChange(
                                      "Contract effective date",
                                      date
                                    )
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  className="date-input"
                                  placeholderText="dd-MM-yyyy"
                                  onBlur={() => {
                                    handleSaveOnBlur("Contract effective date");
                                    setActiveTermsAndConditions(false);
                                  }}
                                  popperPlacement="top-start"
                                />
                                <img
                                  src="/calendar.svg"
                                  alt="Calendar"
                                  className="calendar-icon"
                                  onClick={() => {
                                    if (fromDateRef.current) {
                                      fromDateRef.current.setOpen(true);
                                    }
                                  }}
                                />
                              </div>
                            ) : (
                              <span className="date-value">
                                {contractData["Contract effective date"] ||
                                  "N/A"}
                              </span>
                            )}
                          </div>

                          {/* Contract To Date */}
                          <div className="contract-date">
                            <span className="date-label">To</span>
                            {activeTermsAndConditions ? (
                              <div className="datepicker-wrapper">
                                <DatePicker
                                  ref={toDateRef}
                                  selected={
                                    editedData["Contract duration to date"]
                                      ? new Date(
                                          editedData[
                                            "Contract duration to date"
                                          ]
                                        )
                                      : contractData[
                                          "Contract duration to date"
                                        ]
                                      ? new Date(
                                          contractData[
                                            "Contract duration to date"
                                          ]
                                        )
                                      : null
                                  }
                                  onChange={(date) =>
                                    handleDateChange(
                                      "Contract duration to date",
                                      date
                                    )
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  className="date-input"
                                  placeholderText="dd-MM-yyyy"
                                  onBlur={() => {
                                    handleSaveOnBlur(
                                      "Contract duration to date"
                                    );
                                    setActiveTermsAndConditions(false);
                                  }}
                                  popperPlacement="top-start"
                                />
                                <img
                                  src="/calendar.svg"
                                  alt="Calendar"
                                  className="calendar-icon"
                                  onClick={() => {
                                    if (toDateRef.current) {
                                      toDateRef.current.setOpen(true);
                                    }
                                  }}
                                />
                              </div>
                            ) : (
                              <span className="date-value">
                                {contractData["Contract duration to date"] ||
                                  "N/A"}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Payment Terms */}
                      <div className="payment-terms">
                        <p className="label-terms">Payment Terms</p>
                        {activeTermsAndConditions ? (
                          <textarea
                            className="w-[946px] h-[104px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] p-[10px] ml-[35px] resize-none break-words font-outfit"
                            value={
                              editedData["Payment terms"] ??
                              contractData["Payment terms"] ??
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange("Payment terms", e.target.value)
                            }
                            onBlur={() => {
                              handleSaveOnBlur("Payment terms");
                              setActiveTermsAndConditions(false);
                            }}
                          />
                        ) : (
                          (() => {
                            const value = contractData["Payment terms"];
                            if (value && value.includes(":")) {
                              const lines = value.split("\n").filter(Boolean);
                              return (
                                <table
                                  className="financial-terms-table"
                                  style={{
                                    marginLeft: "38px",
                                    marginTop: "10px",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th>Term</th>
                                      <th>Details</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {lines.map((line, idx) => {
                                      const [key, val] = line.split(":");
                                      return (
                                        <tr key={idx}>
                                          <td>{key?.trim() || "—"}</td>
                                          <td>{val?.trim() || "—"}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              );
                            }

                            return (
                              <p className="value ml-[35px]">
                                {value || "N/A"}
                              </p>
                            );
                          })()
                        )}
                      </div>

                      <div
                        style={{
                          borderTop: "1px solid #ccc",
                          margin: "20px 0",
                          width: "100%",
                        }}
                      ></div>

                      {/* Termination Clause */}
                      <div
                        className="clause-header-contract flex items-center justify-between w-full cursor-pointer"
                        onClick={() => toggleClause("termination")}
                      >
                        <p className="termination-title font-medium text-lg">
                          Termination Clause
                        </p>
                        <img
                          src={
                            openClauses.termination
                              ? "/up-arrow.svg"
                              : "/down-arrow.svg"
                          }
                          alt={openClauses.termination ? "Collapse" : "Expand"}
                          className="toggle-icon w-6 h-6"
                        />
                      </div>

                      {openClauses.termination && (
                        <div className="clause-content">
                          {activeTermsAndConditions ? (
                            <textarea
                              className="w-[946px] h-[104px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] p-[10px] ml-[35px] resize-none break-words whitespace-pre-wrap font-outfit"
                              value={
                                editedData["Termination clause"] ??
                                contractData["Termination clause"] ??
                                ""
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "Termination clause",
                                  e.target.value
                                )
                              }
                              onBlur={() => {
                                handleSaveOnBlur("Termination clause");
                                setActiveTermsAndConditions(false);
                              }}
                            />
                          ) : (
                            (() => {
                              const value = contractData["Termination clause"];
                              if (value && value.includes(":")) {
                                const lines = value.split("\n").filter(Boolean);
                                return (
                                  <table
                                    className="financial-terms-table"
                                    style={{ marginLeft: "40px" }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Clause</th>
                                        <th>Details</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {lines.map((line, idx) => {
                                        const [key, val] = line.split(":");
                                        return (
                                          <tr key={idx}>
                                            <td>{key?.trim() || "—"}</td>
                                            <td>{val?.trim() || "—"}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                );
                              }

                              return (
                                <p className="termination-clause-desc ml-[35px]">
                                  {value || "N/A"}
                                </p>
                              );
                            })()
                          )}
                        </div>
                      )}

                      <div
                        style={{
                          borderTop: "1px solid #ccc",
                          margin: "20px 0",
                          width: "100%",
                        }}
                      ></div>

                      <div
                        className="clause-header flex items-center justify-between w-full cursor-pointer"
                        onClick={() => toggleClause("confidentiality")}
                      >
                        <p className="font-medium text-lg">
                          Confidentiality Clause
                        </p>
                        <img
                          src={
                            openClauses.confidentiality
                              ? "/up-arrow.svg"
                              : "/down-arrow.svg"
                          }
                          alt={
                            openClauses.confidentiality ? "Collapse" : "Expand"
                          }
                          className="toggle-icon w-6 h-6"
                        />
                      </div>

                      {openClauses.confidentiality && (
                        <div className="clause-content">
                          {activeTermsAndConditions ? (
                            <textarea
                              className="w-[946px] h-[104px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] p-[10px] resize-none break-words whitespace-pre-wrap ml-[35px] font-outfit"
                              value={
                                editedData["Confidentiality clause"] ??
                                contractData["Confidentiality clause"] ??
                                ""
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "Confidentiality clause",
                                  e.target.value
                                )
                              }
                              onBlur={() => {
                                handleSaveOnBlur("Confidentiality clause");
                                setActiveTermsAndConditions(false);
                              }}
                            />
                          ) : (
                            (() => {
                              const value =
                                contractData["Confidentiality clause"];
                              if (value && value.includes(":")) {
                                const lines = value.split("\n").filter(Boolean);
                                return (
                                  <table
                                    className="financial-terms-table"
                                    style={{ marginLeft: "37px" }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Term</th>
                                        <th>Details</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {lines.map((line, idx) => {
                                        const [key, val] = line.split(":");
                                        return (
                                          <tr key={idx}>
                                            <td>{key?.trim() || "—"}</td>
                                            <td>{val?.trim() || "—"}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                );
                              }

                              return (
                                <p className="termination-clause-desc ml-[35px]">
                                  {value || "N/A"}
                                </p>
                              );
                            })()
                          )}
                        </div>
                      )}

                      <div
                        style={{
                          borderTop: "1px solid #ccc",
                          margin: "20px 0",
                          width: "100%",
                        }}
                      ></div>

                      {/* Governing Law */}
                      <div
                        className="clause-header flex items-center justify-between w-full cursor-pointer"
                        onClick={() => toggleClause("governing")}
                      >
                        <p className="font-medium text-lg">Governing Law</p>
                        <img
                          src={
                            openClauses.governing
                              ? "/up-arrow.svg"
                              : "/down-arrow.svg"
                          }
                          alt={openClauses.governing ? "Collapse" : "Expand"}
                          className="toggle-icon w-6 h-6"
                        />
                      </div>

                      {openClauses.governing && (
                        <div className="clause-content">
                          {activeTermsAndConditions ? (
                            <textarea
                              className="w-[946px] h-[104px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] p-[10px] resize-none break-words whitespace-pre-wrap ml-[35px] font-outfit"
                              value={
                                editedData["Governing law"] ??
                                contractData["Governing law"] ??
                                ""
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "Governing law",
                                  e.target.value
                                )
                              }
                              onBlur={() => {
                                handleSaveOnBlur("Governing law");
                                setActiveTermsAndConditions(false);
                              }}
                            />
                          ) : (
                            (() => {
                              const value = contractData["Governing law"];
                              if (value && value.includes(":")) {
                                const lines = value.split("\n").filter(Boolean);
                                return (
                                  <table
                                    className="financial-terms-table"
                                    style={{ marginLeft: "37px" }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Term</th>
                                        <th>Details</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {lines.map((line, idx) => {
                                        const [key, val] = line.split(":");
                                        return (
                                          <tr key={idx}>
                                            <td>{key?.trim() || "—"}</td>
                                            <td>{val?.trim() || "—"}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                );
                              }

                              return (
                                <p className="termination-clause-desc ml-[35px]">
                                  {value || "N/A"}
                                </p>
                              );
                            })()
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </section>

            <section
              className="mt-3"
              style={{
                width: "100%",
              }}
            >
              <div className="accordion-item-invoice">
                <div
                  className="accordion-header"
                  onClick={() => toggleSection("financialTerms")}
                >
                  <p className="financial">
                    <span>
                      <img src="/financial.svg" alt="Financial Icon" />
                    </span>{" "}
                    Financial Terms
                  </p>
                  {openSections.financialTerms && !activeFinancialTerm && (
                    <img
                      src="/edit-icon.svg"
                      alt="Edit"
                      className="edit-icon"
                      style={{
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        marginRight: "12px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditClick("FinancialTerms"); // Only this section toggles edit mode
                      }}
                    />
                  )}
                  <div className="header-icons">
                    <img
                      src={
                        openSections.financialTerms
                          ? "/up-arrow.svg"
                          : "/down-arrow.svg"
                      }
                      alt={openSections.financialTerms ? "Collapse" : "Expand"}
                      className="toggle-icon-fin"
                    />
                  </div>
                </div>
                {openSections.financialTerms && (
                  <div className="accordion-content">
                    {activeFinancialTerm ? (
                      <textarea
                        className="w-full h-[150px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium p-[10px] resize-none whitespace-pre-wrap break-words font-outfit"
                        value={
                          editedData["Financial terms"] ||
                          contractData["Financial terms"] ||
                          ""
                        }
                        onChange={(e) =>
                          setEditedData((prevData) => ({
                            ...prevData,
                            "Financial terms": e.target.value,
                          }))
                        }
                        onBlur={() => {
                          handleSaveOnBlur("Financial terms");
                          setActiveFinancialTerm(false); // Exit edit mode after saving
                        }}
                      />
                    ) : contractData["Financial terms"] ? (
                      <table className="financial-terms-table">
                        <thead>
                          <tr>
                            <th>Description</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {contractData["Financial terms"]
                            .split("\n")
                            .map((line, index) => {
                              const [description, value] = line.split(":");
                              return (
                                <tr key={index}>
                                  <td>{description.trim()}</td>
                                  <td>{value ? value.trim() : "N/A"}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    ) : (
                      <p>No Financial Terms available.</p>
                    )}
                  </div>
                )}
              </div>
            </section>

            <section
              className="mt-3"
              style={{
                width: "100%",
              }}
            >
              <div className="accordion-item-invoice">
                <div
                  className="accordion-header"
                  onClick={(e) => {
                    if (!activeLegalClause) {
                      toggleSection("legalClauses");
                    }
                  }}
                >
                  <p className="financial">
                    <span>
                      <img src="/legal.svg" alt="Legal Icon" />
                    </span>{" "}
                    Legal Clauses
                  </p>
                  {openSections.legalClauses && !activeLegalClause && (
                    <img
                      src="/edit-icon.svg"
                      alt="Edit"
                      className="edit-icon"
                      style={{
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        marginRight: "8px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditClick("LegalClauses"); // Enables edit mode only for Legal Clauses
                      }}
                    />
                  )}
                  <div className="header-icons">
                    <img
                      src={
                        openSections.legalClauses
                          ? "/up-arrow.svg"
                          : "/down-arrow.svg"
                      }
                      alt={openSections.legalClauses ? "Collapse" : "Expand"}
                      className="toggle-icon-legal"
                    />
                  </div>
                </div>

                {openSections.legalClauses && (
                  <div className="accordion-content legal-clauses-container">
                    {activeLegalClause ? (
                      <textarea
                        className="w-full h-[150px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium p-[10px] resize-none whitespace-pre-wrap break-words font-outfit"
                        value={
                          editedData["Legal clauses"] ??
                          contractData["Legal clauses"] ??
                          ""
                        } // FIX: Ensuring value is not null
                        onChange={(e) =>
                          setEditedData((prevData) => ({
                            ...prevData,
                            "Legal clauses": e.target.value,
                          }))
                        }
                        onBlur={(e) => {
                          handleSaveOnBlur("Legal clauses");
                          setActiveLegalClause(false); // Close edit mode when clicking outside
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    ) : contractData["Legal clauses"] ? (
                      <div className="legal-clauses-list">
                        {contractData["Legal clauses"]
                          .split("\n")
                          .map((clause, index) => (
                            <p key={index} className="legal-clause-item">
                              {clause.trim()}
                            </p>
                          ))}
                      </div>
                    ) : (
                      <p>No Legal Clauses available.</p>
                    )}
                  </div>
                )}
              </div>
            </section>

            <section className="notes-sections">
              <div className="notes-items" ref={notesRef}>
                <div
                  className="notes-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p className="notes" style={{ margin: 0 }}>
                    <span>
                      <img src="/notes.svg" alt="" />
                    </span>{" "}
                    Notes
                  </p>
                </div>
                <div style={{ position: "relative", width: "100%" }}>
                  <textarea
                    placeholder="Enter your comments here..."
                    className="notes-input custom-placeholder-invoice"
                    style={{
                      width: "100%",
                    }}
                    value={userNote}
                    onChange={(e) => setUserNote(e.target.value)}
                    onFocus={() => setIsEditingNote(true)} // Set editing flag when focused
                  />
                </div>
                {isSaving && (
                  <p
                    style={{
                      fontSize: "12px",
                      color: "green",
                      marginTop: "5px",
                    }}
                  ></p>
                )}
              </div>
            </section>
          </>
        ) : (
          <p>Loading contract details...</p>
        )}
      </div>
      {isModalOpen && (
        <div className="custom-modal-overlay-inline show">
          <div className="custom-modal-content-custom active">
            <button
              className="close-modal-custom"
              onClick={() => setIsModalOpen(false)}
            >
              ×
            </button>

            <h2 className="custom-modal-title-custom">Custom Fields</h2>
            <p className="custom-modal-subtitle-custom">
              You can only create up to 3 custom fields per document.
              <br />
              Deleting a field won’t reset the limit.
            </p>

            <div className="custom-modal-tabs-custom">
              <button
                className={`manage-btn-custom ${
                  selectedTab === "manage" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("manage")}
              >
                {customFieldsLoading
                  ? "Loading..."
                  : `Manage Existing Fields (${customFields.length}/3)`}
              </button>

              <button
                className={`create-btn-custom ${
                  selectedTab === "create" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("create")}
              >
                Create New Field
              </button>
            </div>

            {selectedTab === "create" && (
              <>
                <label className="field-label-custom">
                  Field name{" "}
                  <img
                    src="/bulb.svg"
                    alt="Hint"
                    className="label-icon-custom"
                  />
                </label>
                <input
                  type="text"
                  className="input-field-custom"
                  value={fieldName}
                  onChange={(e) => setFieldName(e.target.value)}
                  placeholder={
                    isMaxFieldsReached
                      ? "Maximum 3 fields allowed. Please delete one to add new."
                      : "Enter your field name here"
                  }
                  disabled={isMaxFieldsReached}
                />

                <label className="field-label-custom">
                  Extraction Prompt{" "}
                  <img
                    src="/bulb.svg"
                    alt="Hint"
                    className="label-icon-custom"
                  />
                </label>
                <textarea
                  className="textarea-field-custom"
                  value={fieldPrompt}
                  onChange={(e) => setFieldPrompt(e.target.value)}
                  placeholder={
                    isMaxFieldsReached
                      ? "Cannot enter prompt. Maximum limit reached."
                      : "Enter your Extraction Prompts here"
                  }
                  disabled={isMaxFieldsReached}
                />

                <button
                  className={`add-field-btn-custom ${
                    isFilled && !loadingAddField && !isMaxFieldsReached
                      ? "active"
                      : ""
                  }`}
                  onClick={handleAddField}
                  disabled={loadingAddField || isMaxFieldsReached}
                >
                  {loadingAddField ? "Adding..." : "Add Field"}
                </button>
              </>
            )}

            {selectedTab === "manage" && (
              <div>
                <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
                  <div className="flex mt-2 gap-[60px]">
                    <h2 className="field-name-custom">Field Name</h2>
                    <h2 className="field-name-custom">Prompt</h2>
                  </div>

                  {Array.isArray(customFields) && customFields.length > 0 ? (
                    customFields.map((field, index) => (
                      <div key={index}>
                        <div className="flex items-start gap-[26px] mt-[12px]">
                          <p className="text-[#1A1A1A] text-sm font-medium w-[109px] whitespace-nowrap">
                            {field.field}
                          </p>
                          <p className="text-[#1A1A1A] text-sm w-[139px]">
                            {field.description}
                          </p>
                          <button
                            className="button-red-custom-field"
                            onClick={() => {
                              setDeletingField(field.field); // disable this button
                              handleDeleteField(field.field);
                            }}
                            disabled={deletingField === field.field}
                          >
                            {deletingField === field.field
                              ? "Deleting"
                              : "Delete"}
                            <img
                              src="/delete-icon-red.svg"
                              alt="Delete"
                              className="delete-lineitems"
                            />
                          </button>
                        </div>
                        <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
                      </div>
                    ))
                  ) : (
                    <p className="text-sm text-gray-500 ml-2 mt-3">
                      No custom fields available.
                    </p>
                  )}
                </div>

                <div>
                  <button
                    className={`add-field-btn-custom-two ${
                      isFilled ? "active" : ""
                    }`}
                    onClick={async () => {
                      await fetchContractDetails(); // re-fetch latest data
                      setIsModalOpen(false); // then close modal
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {isReminderModalOpen && (
        <div className="reminder-overlay">
          <div className="reminder-modal">
            <button
              className="close-reminder"
              onClick={() => setIsReminderModalOpen(false)}
            >
              ×
            </button>

            <h2 className="reminder-title">
              {selectedDateType
                ? `Set a Reminder for ${selectedDateType}`
                : "Schedule a Contract Reminder"}
            </h2>
            <p className="reminder-desc">
              We’ll send you an email reminder before this Date
            </p>

            <div className="reminder-form mt-[20px]">
              

              <div className="flex items-center mb-4">
                <label className="remind-me-rem mt-2">Remind Me On</label>
                <ReminderDropdown
                  selected={reminderTimeframe}
                  onChange={(val) => setReminderTimeframe(val)}
                />
              </div>

              {/* Note Textarea */}
              <div className="flex mt-4">
                <label className="note-reminder">
                  Note <span className="optional-rem pt-2">(optional)</span>
                </label>
                <textarea
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  className="reminder-textarea ml-2 pl-3 pt-1"
                  placeholder="Add a note for this reminder (optional)"
                />
              </div>

              {/* Buttons */}
              <div className="reminder-buttons mb-2">
                {!reminderDate && (
                  <>
                    <button
                      className="cancel-reminder"
                      onClick={() => setIsReminderModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="save-reminder"
                      onClick={
                        reminders.some(
                          (r) =>
                            r.date_type.toLowerCase().trim() ===
                            selectedDateType.toLowerCase().trim()
                        )
                          ? handleUpdateReminder
                          : handleSaveReminder
                      }
                      disabled={
                        isSavingReminder ||
                        !selectedDateType ||
                        !reminderTimeframe
                      }
                    >
                      {isSavingReminder
                        ? "Saving..."
                        : reminders.some(
                            (r) =>
                              r.date_type.toLowerCase().trim() ===
                              selectedDateType.toLowerCase().trim()
                          )
                        ? "Update"
                        : "Save Reminder"}
                    </button>
                  </>
                )}

                {reminderDate && (
                  <div className="flex gap-2">
                    {/* Delete Button */}
                    <button
                      className="save-remindersss ml-1"
                      onClick={() => handleDeleteReminder(selectedDateType)}
                      disabled={isDeletingReminder}
                    >
                      {isDeletingReminder ? "Deleting..." : "Delete"}
                    </button>

                    {/* Update Button */}
                    <button
                      className="save-reminderss"
                      onClick={handleUpdateReminder}
                      disabled={
                        isSavingReminder ||
                        !selectedDateType ||
                        !reminderTimeframe
                      }
                    >
                      {isSavingReminder ? "Saving..." : "Update"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showErrorPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="design-for-alerts">
            <img
              src="/alert-icon.svg"
              alt="Alert logo"
              className="alert-icon-design"
            />
            <h2 className="alerts-heading mt-2">Can’t Complete Request</h2>
            <p className="alerts-heading-response">{errorMessage}</p>
            <button
              onClick={() => setShowErrorPopup(false)}
              className="alerts-button-okay"
            >
              Okay
            </button>
          </div>
        </div>
      )}

      {reminderSuccessMessage && (
        <div className="fixed top-[12rem] left-1/2 transform -translate-x-1/2 inline-flex items-center p-3 bg-white border border-gray-200 shadow-md rounded-md text-sm text-gray-700 z-[100]">
          <img
            src="/green-icon-tick.svg"
            className="mr-2 w-4 h-4"
            alt="Success"
          />
          {reminderSuccessMessage}
        </div>
      )}
    </div>
  );
};

export default ContractDetails;
